import { render, staticRenderFns } from "./ProfitLossYear.vue?vue&type=template&id=5bb24838&scoped=true&"
import script from "./ProfitLossYear.vue?vue&type=script&lang=js&"
export * from "./ProfitLossYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb24838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb24838')) {
      api.createRecord('5bb24838', component.options)
    } else {
      api.reload('5bb24838', component.options)
    }
    module.hot.accept("./ProfitLossYear.vue?vue&type=template&id=5bb24838&scoped=true&", function () {
      api.rerender('5bb24838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FinanceManage/UsaReport/ProfitLossYear.vue"
export default component.exports